export const OPEN = "OPEN";
export const CLOSED = "CLOSED";
export const TWOWAY = "2-Way";
export const FOURWAY = "4-Way";
